import { render } from "./AssignmentOverride.vue?vue&type=template&id=7d97312e"
import script from "./AssignmentOverride.vue?vue&type=script&lang=js"
export * from "./AssignmentOverride.vue?vue&type=script&lang=js"

import "./AssignmentOverride.vue?vue&type=style&index=0&id=7d97312e&lang=css"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "7d97312e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d97312e', script)) {
    api.reload('7d97312e', script)
  }
  
  module.hot.accept("./AssignmentOverride.vue?vue&type=template&id=7d97312e", () => {
    api.rerender('7d97312e', render)
  })

}

script.__file = "src/components/AssignmentOverride.vue"

export default script